import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreatorV2 from "../../common/FormCreatorV2";

import {
  formCreatorConvertToValues,
  useForm,
  getField,
} from "../../common/FormCreator/helpers";
import history from "../../history";
import { postABMForms } from "../../redux/actions/abmActions";

const DeclarationsForm = ({ appData, postABMFormFunc }) => {
  let initialData = {};

  const { firstName = "", lastName = "" } = appData;

  if (appData.abmOnboarding && appData.abmOnboarding.declarations) {
    initialData = {
      ...initialData,
      ...appData.abmOnboarding.declarations,
    };
  }

  const getVal = getField(initialData);

  const initialState = {
    Declarations1: {
      title: "Applicant Declaration (1) ",
      type: "heading",
      textDescription: [
        "The information I will provide in this application is the truth, and I acknowledge that to knowingly make any false statement in connection with an application for an Security ID card, is a criminal offence under the Aviation Security Act 1982 and will lead to an automatic refusal of the application and the withdrawal of employment.",
      ],
    },
    Declarations2: {
      title: "I have read and understood and agree to the above declaration.",
      value: getVal("Declarations2"),
      type: "singlecheckbox",
      mandatory: true,
    },
    Declarations3: {
      title: "Applicant Declaration (2)",
      type: "heading",
      textDescription: [
        "I declare that I have no disqualifying criminal convictions other than any that are treated as spent under the Rehabilitation of Offenders Act 1974. I have given a true and accurate account of my personal, employment and criminal record history. Throughout the term of my employment with ABM I shall declare any criminal convictions that may arise to my employer within 14 days. In the event that I do not declare this information I am aware that I will be at risk at having my ID pass confiscated and my employment therefore terminated.",
      ],
    },
    Declarations4: {
      title: "I have read and understood and agree to the above declaration.",
      value: getVal("Declarations4"),
      type: "singlecheckbox",
      mandatory: true,
    },
    Declarations5: {
      title: "Applicant Declaration (3)",
      type: "heading",
      textDescription: [
        "ABM is committed to collecting and using personal information responsibly, securely and fairly. The information provided in this form and the Security ID application will be stored in electronic format and will be used for the following purposes:",
        "• to check the eligibility and suitability of applicants to hold an airport Security ID card;",
        "• to administer the Security ID Scheme in accordance with regulatory requirements;",
        "• to manage and record access to the security restricted areas;",
        "• to investigate allegations of misuse of Security ID cards and misconduct at work;",
        " • to prevent and detect crime and for the purposes of national security; and",
        "• to research into airport surface access opportunities.",
        "In order to fulfil these purposes ABM do need to disclose information to, third party organisations, the police and government agencies. They will only use the personal information provided by us for these purposes and in some instances, this may require information to be transferred overseas but we will make sure that information remains protected and secure. In the case of all disclosures we will always ensure the disclosure is legitimate and proportionate for the purpose and meets compliance with the General Data Protection Regulation (GDPR) and the Data Protection Act 2018 (DPA).",
        "We keep personal information in line with our retention policy which ensures that we keep details on employees for no longer than is necessary. Information will be retained in a secure environment and access to it will be restricted according to the 'need to know' principle. We will disclose your personal data to other parties who are involved in the application, issue, control and monitoring of security passes and related permits. Such personal data may include your identity, contact details, employment history, references, criminal record data, driving licence data and any documents which may display such data. MAG may suspend or remove a Security ID card on a permanent or temporary basis without notice if there are concerns as to the suitability to hold a Security ID card. In such circumstances further details may not always be provided.",
      ],
    },
    Declarations6: {
      title: "I have read and understood and agree to the above declaration.",
      value: getVal("Declarations6"),
      type: "singlecheckbox",
      mandatory: true,
    },
    Declarations7: {
      title: "Applicant Declaration (4)",
      type: "heading",
      textDescription: [
        "I give my permission for ABM Aviation UK Limited to carry out a CTC (Counter Terrorism Check) check if applicable.",
        "I understand that deployment on such roles is conditional on satisfactory results and unsatisfactory results could lead to the withdrawal of the offer of employment.",
      ],
    },
    Declarations8: {
      title: "I have read and understood and agree to the above declaration.",
      value: getVal("Declarations8"),
      type: "singlecheckbox",
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postABMFormFunc("declarations", {
      ...fieldValuesPayload,
      name: `${firstName} ${lastName}`,
    });

    history.push("/profile/edit/ABM-onboarding");
  };

  return (
    <FormCreatorV2
      formTitle={"Declarations"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit} // handles save to JSON
      handleCancel={() => history.push("/profile/edit/ABM-onboarding")}
      onboardingBranch={"ABM"}
    />
  );
};

DeclarationsForm.propTypes = {
  appData: any,
  postABMFormFunc: func,
};

const mapDispatchToProps = {
  postABMFormFunc: postABMForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(DeclarationsForm);
